export default __webpack_public_path__ + "static/media/Guru-Parampara-26.41ad24bd.png";